import { ICamera } from "@/src/llm/Camera"; /* Been Here */


export interface ISavedState {
  phase: number;
  phaseTime: number;
  camera: ICamera;
}


export let SavedState = {
  state: null as ISavedState | null,
};

/* Observed */